/* eslint-disable */ import { attributeSelectionComponent, detailComponent, entityHeaderComponent, memoEval, sceneEntitySelectHotspotComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
import { HandrailEndType, HandrailPossibleWallEndType } from '../model/index.js';
export const handrailEndComponents = [
    attachComponent.withComponent(detailComponent, 'main', true).withEntity('HandrailEnd').attach(memoEval(()=>[], ()=>({
            title: 'Handrail End',
            subtitle: '',
            description: ''
        }))),
    attachComponent.withComponent(entityHeaderComponent, 'main', true).withEntity('HandrailEnd').attach(memoEval(()=>[], ()=>({}))),
    attachComponent.withComponent(sceneEntitySelectHotspotComponent, 'main', true).withEntity('HandrailEnd').withGradualFilter({
        navigationStates: [
            'Properties'
        ],
        active: (self)=>self.$selectionFilter
    }).attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.x,
            self.y,
            self.z
        ], (x, y, z)=>({
            offsetX: x,
            offsetY: y,
            offsetZ: z
        }))),
    attachComponent.withComponent(attributeSelectionComponent, 'possibleWallEndType', true).withEntity('HandrailEnd').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.possibleWallEndType
        ], (possibleWallEndType)=>({
            value: possibleWallEndType,
            options: [
                {
                    label: 'End Cap',
                    value: 'Free'
                },
                {
                    label: 'Wall Fixing',
                    value: 'Wall'
                }
            ]
        })), (state)=>{
        HandrailPossibleWallEndType.assert(state.value);
        return {
            possibleWallEndType: state.value
        };
    }),
    attachComponent.withComponent(attributeSelectionComponent, 'wallEndType', true).withEntity('HandrailEnd').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.endType
        ], (endType)=>({
            value: endType,
            options: [
                {
                    label: 'Oblong',
                    value: 'OblongWallPlate'
                },
                {
                    label: 'Round',
                    value: 'RoundWallPlate'
                }
            ]
        })), (state)=>{
        HandrailEndType.assert(state.value);
        return {
            endType: state.value
        };
    }),
    attachComponent.withComponent(attributeSelectionComponent, 'freeEndType', true).withEntity('HandrailEnd').attach(memoEval(// @ts-ignore
    (self)=>// keep deps on a separate line so @ts-ignore only covers the parameter
        [
            self.endType
        ], (endType)=>({
            value: endType,
            options: [
                {
                    label: 'Radiused end cap',
                    value: 'RadiusedEndCap'
                },
                {
                    label: 'Domed end cap',
                    value: 'DomedEndCap'
                },
                {
                    label: 'Flat end cap',
                    value: 'FlatEndCap'
                }
            ]
        })), (state)=>{
        HandrailEndType.assert(state.value);
        return {
            endType: state.value
        };
    })
];

//# sourceMappingURL=handrail-end.js.map